import React from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import { renderFieldHora } from '../../util/inputs';
import { showSuccessMsg } from '../../util/messagesUtil';
import cadastrarControleEmissaoBpeEmLote from '../../actions/bpe/cadastrarControleEmissaoBpeEmLote';
import { gerarHashForString } from '../../util/stringUtil';
import $ from 'jquery';

export class ModalCadastrarControleEmissaoBPeEmLote extends React.Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.limparFormulario = this.limparFormulario.bind(this);
    this.carregarHorariosSalvos = this.carregarHorariosSalvos.bind(this);
    this.state = {
      selecionados: [],
      possuiaHorariosSalvos: false
    };
  }

  componentDidMount() {
    $('#modalCadastrarControleEmissaoBPeEmLote').on('show.bs.modal', this.carregarHorariosSalvos);
  }

  componentWillUnmount() {
    $('#modalCadastrarControleEmissaoBPeEmLote').off('show.bs.modal', this.carregarHorariosSalvos);
  }

  // O lote grava em todas as configurações da empresa: carrega os horários já salvos nelas, sem repetir
  carregarHorariosSalvos() {
    const configuracoes = Array.isArray(this.props.configuracoesBPe) ? this.props.configuracoesBPe : [];
    const controles = [];
    configuracoes
      .forEach(config => (config.controlesEmissaoBpe || []).forEach(it => {
        const hash = gerarHashForString(`${it.horaInicio}-${it.horaFim}`);
        if (!controles.some(c => c.hash === hash)) {
          controles.push({ hash, horaInicio: it.horaInicio, horaFim: it.horaFim });
        }
      }));
    controles.sort((a, b) => a.horaInicio.localeCompare(b.horaInicio));
    this.props.definirControlesEmissaoBpe(controles);
    this.setState({ selecionados: [], possuiaHorariosSalvos: controles.length > 0 });
  }

  limparFormulario() {
    this.props.reset('formularioCadastroControleEmLote');
    this.props.limparControleEmissaoBpe();
    this.setState({ selecionados: [], possuiaHorariosSalvos: false });
  }

  alternarSelecao(hash, checked) {
    this.setState({
      selecionados: checked
        ? [...this.state.selecionados, hash]
        : this.state.selecionados.filter(it => it !== hash)
    });
  }

  alternarSelecaoTodos(checked) {
    this.setState({ selecionados: checked ? this.props.controleEmissaoBpe.map(it => it.hash) : [] });
  }

  removerHorario(controle) {
    this.props.removerControle(controle);
    this.setState({ selecionados: this.state.selecionados.filter(it => it !== controle.hash) });
  }

  removerSelecionados() {
    const { selecionados } = this.state;
    this.props.definirControlesEmissaoBpe(this.props.controleEmissaoBpe.filter(it => !selecionados.includes(it.hash)));
    this.setState({ selecionados: [] });
  }

  limparCampos() {
    this.props.changeFieldValue('formularioCadastroControleEmLote',
      'dataHora', '');
    this.props.changeFieldValue('formularioCadastroControleEmLote',
      'horaInicio', '');
    this.props.changeFieldValue('formularioCadastroControleEmLote',
      'horaFim', '');

  }

  limparCamposControle() {
    this.props.changeFieldValue('formularioCadastroControleEmLote', 'horaInicio', '');
    this.props.changeFieldValue('formularioCadastroControleEmLote', 'horaFim', '');
  }

  submit() {
    this.props.cadastrarControleEmissaoBpeEmLote(this.montarParametroControle()).then(() => {
      showSuccessMsg('Controle Emissao cadastro em Lote com sucesso');
      this.props.buscarConfiguracoesBPe();
      this.limparCampos();
      this.props.buscarConfiguracoesBPe()
      this.fecharModal();
    })
  }

  fecharModal() {
    $('#modalCadastrarControleEmissaoBPeEmLote')
        .modal('hide');
    $('#modalCadastrarControleEmissaoBPeEmLote')
        .hide();
    $('.modal-backdrop')
        .hide();
    this.limparFormulario();
}

  montarParametroControle() {
    return {
      idEmpresa: this.props.codigoEmpresaSelecionada,
      controlesEmissaoBpe: this.props.controleEmissaoBpe
    };
  }

  adicionarControle(event) {
    const controle = {
      hash: gerarHashForString(`${this.props.horaInicio}-${this.props.horaFim}`),
      horaInicio: this.props.horaInicio,
      horaFim: this.props.horaFim,
    };
    this.props.adicionarControle(event, controle);
    this.limparCamposControle();
  }

  exibirAcoesSelecao() {
    const controles = this.props.controleEmissaoBpe || [];
    const { selecionados } = this.state;
    const todosMarcados = controles.length > 0 && controles.every(it => selecionados.includes(it.hash));
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <div className="form-check">
          <input className="form-check-input" type="checkbox" id="marcarTodosControlesLote"
            disabled={controles.length === 0}
            checked={todosMarcados}
            onChange={e => this.alternarSelecaoTodos(e.target.checked)} />
          <label className="form-check-label" htmlFor="marcarTodosControlesLote" style={{ cursor: 'pointer' }}>
            Marcar todos
          </label>
        </div>
        <button type="button" className="vx-btn-secondary"
          disabled={selecionados.length === 0}
          onClick={() => this.removerSelecionados()}>
          <i className="material-icons">delete</i>
          Remover selecionados{selecionados.length > 0 ? ` (${selecionados.length})` : ''}
        </button>
      </div>
    );
  }

  exibirControles() {
    return <table className="table table-sm table-bordered">
      <thead>
        <tr className='text-center'>
          <th style={{ width: 40 }} />
          <th>Hora início</th>
          <th>Hora fim</th>
          <th style={{ width: 100 }} />
        </tr>
      </thead>
      <tbody>
        {!this.props.controleEmissaoBpe || this.props.controleEmissaoBpe.length === 0 ?
          <tr className="alert alert-warning text-center mt-4" role="alert" key={`it_${'index'}`}>
            <td colSpan='4'>
              Nenhum horário foi adicionado.
            </td>
          </tr>
          :
          this.props.controleEmissaoBpe.map(it => <tr key={`it_${it.hash}`}>
            <td className='text-center'>
              <input type="checkbox" style={{ cursor: 'pointer' }}
                checked={this.state.selecionados.includes(it.hash)}
                onChange={e => this.alternarSelecao(it.hash, e.target.checked)} />
            </td>
            <td className='text-center'>
              {it.horaInicio}
            </td>
            <td className='text-center'>
              {it.horaFim}
            </td>
            <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
              <div onClick={() => this.removerHorario(it)}>Remover</div>
            </td>
          </tr>)}
      </tbody>
    </table>
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <div className="modal fade show" id='modalCadastrarControleEmissaoBPeEmLote' role='dialog'
        aria-labelledby='modalCadastrarControleEmissaoBPeEmLote' aria-hidden='true' data-backdrop='static'>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content vx-modal-content">
            <div className="vx-modal-header">
              <div className="vx-modal-header-left">
                <i className="material-icons">playlist_add</i>
                <span className="vx-modal-title">Cadastrar Emissão BPe em Lote</span>
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal"
                onClick={this.limparFormulario}>
                <i className="material-icons">close</i>
              </button>
            </div>
            <form onSubmit={handleSubmit(this.submit)}>
              <div className="vx-modal-body">
                <div className="vx-modal-section">
                  <div className="vx-modal-section-title">
                    <i className="material-icons">schedule</i>Horários
                  </div>
                  <div className="form-row">
                    <div className="col-12 col-sm-4 col-md-3">
                      <Field name="horaInicio"
                        css='form-control'
                        component={renderFieldHora}
                        label="Hora início" />
                    </div>
                    <div className="col-12 col-sm-4 col-md-3">
                      <Field name="horaFim"
                        css='form-control'
                        component={renderFieldHora}
                        label="Hora fim" />
                    </div>
                    <div className="col-12 col-sm-4 col-md-3" style={{ display: 'flex', alignItems: 'flex-end' }}>
                      <button
                        disabled={!this.props.horaInicio || !this.props.horaFim}
                        className="vx-btn-secondary"
                        onClick={(e) => this.adicionarControle(e)}>
                        <i className="material-icons">add</i>
                        Incluir
                      </button>
                    </div>
                  </div>
                  <div className="form-row mt-3">
                    <div className="col-12">
                      {this.exibirAcoesSelecao()}
                      {this.exibirControles()}
                    </div>
                  </div>
                </div>
              </div>
              <div className="vx-modal-footer">
                <button type="submit"
                  disabled={this.props.controleEmissaoBpe.length == 0 && !this.state.possuiaHorariosSalvos}
                  className="vx-btn-primary">
                  <i className="material-icons">save</i>
                  Salvar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    horaInicio: formValueSelector('formularioCadastroControleEmLote')(state, 'horaInicio'),
    horaFim: formValueSelector('formularioCadastroControleEmLote')(state, 'horaFim'),
    configuracoesBPe: state.configuracaoBPe.configuracoesBPe
  }
}

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarControleEmissaoBpeEmLote
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioCadastroControleEmLote'
})(ModalCadastrarControleEmissaoBPeEmLote));